import actionTypes from 'src/modules/redux/actionTypes'

export const setFavouriteAdsFetchedInitially = fetchedInitially => ({
  type: actionTypes.SET_PROFILE_FAVOURITE_ADS_FETCHED_INITIALLY,
  payload: fetchedInitially
})
